// @ts-check
/**
 * Admin gift/sample order creation + AI-assisted recipient extraction.
 * See docs/superpowers/specs/2026-09-17-influencer-gift-orders-design.md.
 */

import api from '../utils/apiClient';

const adminGiftOrderService = {
  /**
   * @param {Object} data
   * @returns {Promise<{id: string, order_number: string, influencer_created?: boolean}>}
   */
  async createGiftOrder(data) {
    return api.post('/api/admin/gift-orders', data);
  },

  /**
   * Parses pasted text (a DM, email, message) into recipient form fields via AI.
   * Never auto-submits — the caller must let the admin review/edit before saving.
   * @param {string} text
   * @returns {Promise<Object>}
   */
  async extractRecipient(text) {
    return api.post('/api/admin/gift-orders/extract-recipient', { text });
  },
};

export default adminGiftOrderService;
